import { Tables } from "@/integrations/supabase/types";
import { fetchApi } from "./base";

export function getGradingCompanies() {
  return fetchApi<{
    success: boolean;
    data: Tables<"grading_companies">[];
  }>(`/api/grading/companies`);
}

export function getGrades() {
  return fetchApi<{
    success: boolean;
    data: Tables<"grades">[];
  }>(`/api/grading/grades`);
}

export function getGradedCardPrice(
  cardId: number,
  gradingCompanyId: string,
  gradeId: number | string,
) {
  return fetchApi<{
    success: boolean;
    data: number | null;
  }>(`/api/grading/price`, {
    method: "GET",
    params: { cardId, gradingCompanyId, gradeId },
  });
}
